// Pure header/footer visibility decision for a URL. Side-effect free (the caller
// supplies `isWebView`) so it can both seed the initial value at construction and
// run on every NavigationEnd — the single source of truth for whether the global
// chrome shows. Routes under /account/* (and a handful of standalone pages) render
// their own chrome, so the global header + footer must stay hidden there.

const HIDE_HEADER_URLS = [
    '', '/', 'login', 'qrLogin', 'mobile', 'invitation', 'invitationSuccess',
    'invitationFailure', 'notfound', 'error', 'gdpr', 'unsupported', 'terms',
    'consent', 'account', 'manage', 'profiles', 'newprofile', 'editprofile',
];

export function resolveDisplayHeader(rawUrl: string, isWebView: boolean): boolean {
    const url = rawUrl.length && rawUrl[0] === '/' ? rawUrl.substring(1) : rawUrl;
    if (isWebView || HIDE_HEADER_URLS.includes(url)) {
        return false;
    }
    // Every /account/* route renders its own chrome via AccountLayout.
    if (rawUrl.startsWith('/account') ||
        rawUrl.indexOf('qrLogin') >= 0 ||
        rawUrl.indexOf('resetPassword') >= 0) {
        return false;
    }
    // mobile, notfound, error, gdpr, unsupported, terms, consent — hide header.
    if (rawUrl.indexOf('mobile') >= 0 || rawUrl.indexOf('notfound') >= 0 || rawUrl.indexOf('error') >= 0 ||
        rawUrl.indexOf('unsupported') >= 0 || rawUrl.indexOf('gdpr') >= 0 ||
        rawUrl.indexOf('consent') >= 0 || rawUrl.indexOf('terms') >= 0) {
        return false;
    }
    return true;
}
